import { Dialog, DialogTitle, Divider, Table, TableBody, TableContainer, TableHead, inputClasses, inputLabelClasses } from '@mui/material'
import React, { useEffect, useState } from 'react';
import Home from '../home/Home'
import Grid2 from '@mui/material/Unstable_Grid2';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Box, Button, TextField } from '@mui/material';
import { Col, Form, Row } from 'react-bootstrap';
import { getDate, getPointId, getUserId } from '../Utils/Common';
import BillingService from '../../Services/billing/BillingService';
import BeSbUpdetionService from '../../Services/BeSbUpdetionService';
import Snacbar from '../Snacbar';
import FileSaver from 'file-saver';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder',
}

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:38px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0.5),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
        color: 'black'
    },
}));
function BeSbUpdation() {

    const [BeSb_values, setBeSb_values] = useState({
        jobno: '',
        beSbno: '',
        beSbDate: getDate(),
        assessablevalue: '',
        duty_Amount: '',
    });
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const [jobEntryValues, setjobEntryValues] = useState({
        txt_customHouseCode: '', txt_customLocation: '', txt_importerIEC: '', txt_importerName: '', txt_branchSrNo: '',
        txt_branchName: '', txt_ForwarderName: '', txt_accValue: '', txt_ServiceType: '', txt_forwarderIecNo: ''
    })
    const [beSbCoby, setbeSbCoby] = useState('');
    const [nonUplodedetails, setnonUplodedetails] = useState([]);
    const [Uplodedetails, setUplodedetails] = useState([]);
    const [Consigment, setConsigment] = useState('');
    const [selected, setSelected] = useState([]);

    const [jobdetailsDialog, setjobdetailsDialog] = useState(false);

    const [saveDsa, setsaveDsa] = useState(true);
    const [UpdateDsa, setUpdateDsa] = useState(true);
    const [DeleteDsa, setDeleteDsa] = useState(true);
    const [savePrc, setsavePrc] = useState(false);
    const [UpdatePrc, setUpdatePrc] = useState(false);
    const [DeletePrc, setDeletePrc] = useState(false);

    const [JobTrackingDetails, setJobTrackingDetails] = useState([]);
    const [BOEDetails, setBOEDetails] = useState([]);

    const BeSb_jobnoHandleChange = (e) => {
        setBeSb_values({ ...BeSb_values, jobno: e.target.value })
        var consigmnt = '';
        if (e.target.value !== '') {
            consigmnt = e.target.value;
        }
        else { consigmnt = '-1' }

        let details = { importer_iec_no: '-1', consignmentNumber: consigmnt, status: '6' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }
    const BeSb_beSbnoHandleChange = (e) => {
        setBeSb_values({ ...BeSb_values, beSbno: e.target.value })
    }
    const BeSb_beSbDateHandleChange = (e) => {
        setBeSb_values({ ...BeSb_values, beSbDate: e.target.value })
    }
    const BeSb_assessablevalueHandleChange = (e) => {
        setBeSb_values({ ...BeSb_values, assessablevalue: e.target.value })
    }
    const BeSb_duty_AmountHandleChange = (e) => {
        setBeSb_values({ ...BeSb_values, duty_Amount: e.target.value })
    }

    ////dialog box
    const jobdetailsOpen = () => {
        setjobdetailsDialog(true)
    }
    const jobdetailsClose = () => {
        setjobdetailsDialog(false)
    }
    ////search
    const searchkeydown = (e) => {
        if (e.key === 'Enter') {
            getJobNoConsoleNonUpload()
        }
    }
    //getData
    const getJobNoConsoleNonUpload = () => {
        var consigmnt = '';
        if (BeSb_values.jobno !== '') {
            consigmnt = BeSb_values.jobno
        }
        else { consigmnt = '-1' }

        let details = { importer_iec_no: '-1', consignmentNumber: consigmnt, status: '6' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const getAllData = async () => {
        BillingService.getnonAudit('6').then(res => { setnonUplodedetails(res.data); });
        BillingService.getAudit('6').then(res => { setUplodedetails(res.data); });
    }

    useEffect(() => {
        getAllData();
    }, []);

    //tableClick
    const getBOE = (val) => {
        BeSbUpdetionService.getBOE(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (lastResult[0] === '') {
                setBeSb_values({ ...BeSb_values, jobno: '', beSbno: '', beSbDate: getDate(), assessablevalue: '', duty_Amount: '' });
            } else {
                setBeSb_values({
                    ...BeSb_values, beSbno: lastResult[0].boe_no, beSbDate: lastResult[0].boe_date, duty_Amount: lastResult[0].dutyAmt,
                    assessablevalue: lastResult[0].assableValue
                });
                setbeSbCoby(lastResult[0].BOECopy);
                setBOEDetails(res.data);
            }
        });
    }

    const getJobTrackingDetails = (val) => {
        setJobTrackingDetails([])
        BeSbUpdetionService.getJobTrackingDetails(val).then((res) => {
            setJobTrackingDetails(res.data);
        })
    }

    const getJobEntryAssign = (val) => {
        BeSbUpdetionService.getJobEntryAssign(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            console.log('lastResult======>' + JSON.stringify(lastResult))
            setjobEntryValues({
                ...jobEntryValues, txt_customHouseCode: lastResult[0].cusHouseCode, txt_customLocation: lastResult[0].cusHouseName, txt_importerIEC: lastResult[0].importer_iec_no,
                txt_importerName: lastResult[0].importer_name, txt_branchSrNo: lastResult[0].branchId, txt_branchName: lastResult[0].branchName, txt_ForwarderName: lastResult[0].forwarder_name,
                txt_accValue: lastResult[0].accessableValue, txt_ServiceType: lastResult[0].serviceType, txt_forwarderIecNo: lastResult[0].forwarder_iecNo
            })
        });
    }

    const editNonSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setBeSb_values({ ...BeSb_values, jobno: '', beSbno: '', beSbDate: getDate(), assessablevalue: '', duty_Amount: '' });
        setsaveDsa(false); setUpdateDsa(true); setDeleteDsa(true);
        setsavePrc(false); setUpdatePrc(false); setDeletePrc(false);
        setConsigment(item.consignmentNumber);
        getBOE(item.consignmentNumber);
        getJobTrackingDetails(item.consignmentNumber);
        getJobEntryAssign(item.consignmentNumber);
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const editSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);
        setsaveDsa(true); setUpdateDsa(false); setDeleteDsa(false);
        setsavePrc(false); setUpdatePrc(false); setDeletePrc(false);
        setConsigment(item.consignmentNumber);
        getBOE(item.consignmentNumber);
        getJobTrackingDetails(item.consignmentNumber);
        getJobEntryAssign(item.consignmentNumber);
    }
    const isBoeSelected = (name) => selected.indexOf(name) !== -1;


    //clickEvents
    const [ImgUpload, setImgUpload] = useState(false);
    const ImgUploadFile = () => {
        if (Consigment !== '') {
            setImgUpload(true);
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job No From Job Table ..!!'); setImgUpload(false);
        }
    }

    const selectFile = (event) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setbeSbCoby(reader.result);
            }
        }

        reader.readAsDataURL(event.target.files[0])

    }

    const saveImage = () => {
        if (Consigment !== '') {
            if (beSbCoby === '' || !beSbCoby) {

                // saveAs(beSbCoby,Consigment+'.pdf');
            } else {
                // var blob = new Blob(beSbCoby, {type: "base64;charset=utf-8"});
                FileSaver.saveAs(beSbCoby, Consigment + ".pdf");
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job No From Job Table ..!!');
        }
    }

    const validate = () => {
        if (BeSb_values.beSbno !== '') {
            if (BeSb_values.assessablevalue !== '') {
                if (BeSb_values.duty_Amount !== '') {
                    return true;
                } else {
                    document.getElementById('DutyyAmnt').focus();
                    setOpen(true); setSeverity('warning'); setMessage('Please Enter Duty Amount ..!!');
                }
            } else {
                document.getElementById('assessableValue').focus();
                setOpen(true); setSeverity('warning'); setMessage('Please Enter assessableValue ..!!');
            }
        } else {
            document.getElementById('beSbNo').focus();
            setOpen(true); setSeverity('warning'); setMessage('Please Enter Checklist No ..!!');
        }
        return false;
    }

    const SaveBeSbUpdetion = () => {
        if (validate() === true) {
            if (Consigment !== '') {
                setsaveDsa(true);
                setsavePrc(true);
                var BOECopy = '';
                if (beSbCoby !== '') {
                    BOECopy = beSbCoby;
                } else {
                    BOECopy = 'null';
                }
                let details = {
                    consignmentId: Consigment, boe_no: BeSb_values.beSbno, boe_date: BeSb_values.beSbDate, BOECopy: BOECopy,
                    createdBy: getUserId(), pointId: getPointId(), assableValue: BeSb_values.assessablevalue, dutyAmt: BeSb_values.duty_Amount,
                    flag: 1, roslAmt: 'null'
                }
                BeSbUpdetionService.insertBOE(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setOpen(true); setSeverity('success'); setMessage(message);
                    } else {
                        setOpen(true); setSeverity('error'); setMessage('Insertion Failed ' + message);
                    } refresh();
                }).catch(error => {
                    setOpen(true); setSeverity('error'); setMessage('Insertion Failed ' + error.message); refresh();
                });
            } else {
                setOpen(true); setSeverity('warning'); setMessage('Please Select Job No From Job Table ..!!')
            }
        }
    }
    const UpdateBeSbUpdetion = () => {
        if (validate() === true) {
            if (Consigment !== '') {
                setUpdateDsa(true);
                setUpdatePrc(true);
                var BOECopy = '';
                if (beSbCoby !== '') {
                    BOECopy = beSbCoby;
                } else {
                    BOECopy = 'null';
                }
                let details = {
                    consignmentId: Consigment, boe_no: BeSb_values.beSbno, boe_date: BeSb_values.beSbDate, BOECopy: BOECopy,
                    createdBy: getUserId(), preparedId: getUserId(), pointId: getPointId(), assableValue: BeSb_values.assessablevalue, dutyAmt: BeSb_values.duty_Amount,
                    flag: 1, roslAmt: 'null'
                }
                BeSbUpdetionService.updateBOE(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setOpen(true); setSeverity('success'); setMessage(message);
                    } else {
                        setOpen(true); setSeverity('error'); setMessage('Updation Failed ' + message);
                    } refresh();
                }).catch(error => {
                    setOpen(true); setSeverity('error'); setMessage('Updation Failed ' + error.message); refresh();
                });
            } else {
                setOpen(true); setSeverity('warning'); setMessage('Please Select Job No From Job Table ..!!')
            }
        }
    }

    const DeleteBeSbUpdetion = () => {
        if (Consigment !== '') {
            setDeleteDsa(true);
            setDeletePrc(true);
            BeSbUpdetionService.deleteBOE(Consigment, 1).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setSeverity('success'); setMessage(message);
                } else {
                    setOpen(true); setSeverity('error'); setMessage('Failed To Delete' + message);
                } refresh();
            }).catch(error => {
                setOpen(true); setSeverity('error'); setMessage('Failed To Delete' + error.message); refresh();
            });
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job No From Job Table ..!!')
        }
    }
    const refresh = () => {
        setsaveDsa(false); setUpdateDsa(true); setDeleteDsa(true);
        setsavePrc(false); setUpdatePrc(false); setDeletePrc(false);
        setBeSb_values({ ...BeSb_values, beSbno: '', beSbDate: '', duty_Amount: '', assessablevalue: '', jobno: '' });
        setjobEntryValues({
            ...jobEntryValues, txt_customHouseCode: '', txt_customLocation: '', txt_importerIEC: '',
            txt_importerName: '', txt_branchSrNo: '', txt_branchName: '', txt_ForwarderName: '', txt_accValue: '', txt_ServiceType: '', txt_forwarderIecNo: ''
        });
        setConsigment('');
        setbeSbCoby('');
        setBOEDetails([]);
        setJobTrackingDetails([]);
        getAllData();
    }
    //handleClose/open
    const handleClose = () => {
        setOpen(false);
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/customactivity');
    }
    const ForwordBotton = () => {
        navigate('/tracking');
    }
    return (
        <div>
            <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <Dialog open={jobdetailsDialog} onClose={jobdetailsClose} fullWidth={true} maxWidth='md'>
                <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', textAlign: 'center', fontWeight: 'bolder' }}>Job Details</DialogTitle>
                <Box>
                    <Grid2 container>
                        <Row className='p-1'>
                            <Col xs={3}>

                                <div><label className='mb-1'><span style={jobentrylablestyle}>IEC_CODE</span><b className='summury '> : {jobEntryValues.txt_importerIEC}</b></label></div>
                                <div> <label className='mb-1 mt-2'> <span style={jobentrylablestyle}>Acc_VAlue</span><b className='summury '> : {jobEntryValues.txt_accValue}</b></label></div>
                                <div><label className='mb-1 mt-2'> <span style={jobentrylablestyle}>CusHouseCode</span><b className='summury '> : {jobEntryValues.txt_customHouseCode}</b></label></div>
                            </Col>
                            <Col>
                                <div ><label className='summury  mb-1' style={{ fontSize: '5px' }}> .</label></div>
                                <div><label className='summury mb-1 mt-3' style={{ fontSize: '5px' }}> .</label></div>
                                <div><label className='summury mb-1 mt-3 form-inline'>{jobEntryValues.txt_customLocation}</label></div>
                            </Col>
                            <Col xs={3}>
                                <div><label className='mb-1'><span style={jobentrylablestyle}>IMP_Name</span><b className='summury '>:{jobEntryValues.txt_importerName}</b></label></div>
                                <div><label className='mb-1 mt-2'><span style={jobentrylablestyle}>Forwarder</span><b className='summury '>:{jobEntryValues.txt_ForwarderName}</b></label></div>
                                <div><label className='mb-1 mt-2'><span style={jobentrylablestyle}>Servicetype</span><b className='summury '>:{jobEntryValues.txt_ServiceType}</b></label></div>
                            </Col>
                            <Col>
                                <div ><label className='summury mb-1'></label></div>
                                <div><label className='summury mb-1 mt-2'></label></div>
                                <div><label className='summury mb-1 mt-2'>{jobEntryValues.txt_forwarderIecNo}</label></div>
                            </Col>
                            <Col xs={4}>
                                <div><label className='mb-1'><span style={jobentrylablestyle}>Branch_S.No</span><b className='summury '>:{jobEntryValues.txt_branchSrNo}</b></label></div>
                                <div><label className='mb-1 mt-3'><span style={jobentrylablestyle}>Branch</span><b className='summury '>:{jobEntryValues.txt_branchName}</b></label></div>
                            </Col>
                        </Row>
                    </Grid2>
                </Box>
            </Dialog>

            {/* ///design */}
            <div style={{ paddingLeft: '100px' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '25%' }}>
                        <Item>
                            <Row >
                                <Col xs={1}>
                                    {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                        <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                                </Col>
                                <Col xs={10} >
                                    <CssTextField size='small' label="Job.NO" variant="outlined" className='mt-3 mb-1'
                                        value={BeSb_values.jobno} onChange={BeSb_jobnoHandleChange} onKeyDown={searchkeydown} />
                                </Col>
                            </Row>
                            <Divider />
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>Non BOE Job</lable>
                            <TableContainer sx={{ maxHeight: 300 }}>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {nonUplodedetails.map((item) => {
                                            const isItemSelected = isSelected(item.consignmentId);
                                            return (
                                                <StyledTableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </StyledTableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '50%' }}>
                        <Item>
                            <div style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%' }}><center>BE / SB UPDATION</center></div>
                            <Row className='mt-4'>
                                <Col></Col>
                                <Col style={{ textAlign: 'right' }}>
                                    <Form.Label className='billingIpTitle'>BE / SB NO</Form.Label>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control style={{ fontWeight: 'bold', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontFamily: 'Times New Roman' }}
                                        value={BeSb_values.beSbno} onChange={BeSb_beSbnoHandleChange} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col></Col>
                                <Col style={{ textAlign: 'right' }}>
                                    <Form.Label className='billingIpTitle'>BE SB Date</Form.Label>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control id="SbBeDate" type="date" style={{ fontWeight: 'bold', height: '26px', fontFamily: 'Times New Roman', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }}
                                        value={BeSb_values.beSbDate} onChange={BeSb_beSbDateHandleChange} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col></Col>
                                <Col style={{ textAlign: 'right' }}>
                                    <Form.Label className='billingIpTitle'>Ass.Value</Form.Label>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }}
                                        id='assessableValue' value={BeSb_values.assessablevalue} onChange={BeSb_assessablevalueHandleChange} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col></Col>
                                <Col style={{ textAlign: 'right' }}>
                                    <Form.Label className='billingIpTitle'>Duty Amount</Form.Label>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }}
                                        id='DutyyAmnt' value={BeSb_values.duty_Amount} onChange={BeSb_duty_AmountHandleChange} />
                                </Col>
                                <Col></Col>
                            </Row>
                            {/* /// */}

                            <div className='mt-3 mb-1 form-inline'>
                                <label onClick={ImgUploadFile} style={{ fontFamily: 'Times New Roman' }} className="btn btn-primary" >Upload
                                    {ImgUpload ? <input type="file" accept='.jpg, .jpeg, .gif, .png,.pdf,.doc,.rtf,.txt' onChange={selectFile} hidden /> : null}
                                </label>{' '}
                                <Button size='small' variant="contained" color="primary" style={{ height: '38px', fontFamily: 'Times New Roman' }} onClick={saveImage}>Download BOE Copy</Button>{' '}
                            </div>
                            <div className='mt-2 mb-1 form-inline'>
                                <Button size='small' variant="contained" color='success' style={{ fontFamily: 'Times New Roman' }} className='mt-1' disabled={saveDsa} onClick={SaveBeSbUpdetion}>{savePrc ? 'processing..' : 'Save'}</Button>{' '}
                                <Button size='small' variant="contained" className='mt-1' style={{ fontFamily: 'Times New Roman' }} disabled={UpdateDsa} onClick={UpdateBeSbUpdetion} color="info">{UpdatePrc ? 'processing' : 'Update'}</Button>{' '}
                                <Button size='small' variant="contained" color='error' style={{ fontFamily: 'Times New Roman' }} className='mt-1' disabled={DeleteDsa} onClick={DeleteBeSbUpdetion}>{DeletePrc ? 'processing' : 'Delete'}</Button>{' '}
                                <Button size='small' variant="contained" color='warning' style={{ fontFamily: 'Times New Roman' }} className='mt-1' onClick={refresh}>REFRESH</Button>{' '}
                                <Button size='small' variant="contained" color='primary' style={{ fontFamily: 'Times New Roman' }} className='mt-1' onClick={jobdetailsOpen}>View Job Deatils</Button>{' '}
                            </div>
                            <TableContainer sx={{ maxHeight: 110 }}>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                            <StyledTableCell align='center'>BOE No</StyledTableCell>
                                            <StyledTableCell align='center'>Bill OF Entry Date</StyledTableCell>
                                            <StyledTableCell align='center'>Assessable Value</StyledTableCell>
                                            <StyledTableCell align='center'>Duty Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {BOEDetails.map((item) => (
                                            <StyledTableRow hover key={item.serialNumber}>
                                                <StyledTableCell align='center'>{item.consignmentId}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.boe_no}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.boe_date}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.assableValue}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.dutyAmt}</StyledTableCell>
                                            </StyledTableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '25%' }}>
                        <Item1>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red', marginRight: '70px' }}>BOE Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 360 }}>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Uplodedetails.map((item) => {
                                            const isSelected = isBoeSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isSelected} onClick={() => editSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                </Grid2>
                <Grid2>
                    <Box >
                        <Item >
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 'bold', color: 'red' }}>JOB TRACKING DETAILS</lable>
                            <TableContainer sx={{ maxHeight: 200 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Operation Location</StyledTableCell>
                                            <Divider orientation='vertical' />
                                            <StyledTableCell align='center'>Operation Date</StyledTableCell>
                                            <Divider orientation='vertical' />
                                            <StyledTableCell align='center'>Operation Status</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {JobTrackingDetails.map((item) => (
                                            <StyledTableRow hover key={item.operationStatus}>
                                                <StyledTableCell align='center'>{item.userLocation}</StyledTableCell>
                                                <Divider orientation='vertical' />
                                                <StyledTableCell align='center'>{item.operationDate}</StyledTableCell>
                                                <Divider orientation='vertical' />
                                                <StyledTableCell align='center'>{item.operationStatus}</StyledTableCell>
                                            </StyledTableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                </Grid2>
                <br></br>
                {/* <Divider /> */}
            </div>

        </div >
    )
}

export default BeSbUpdation
